import React from 'react'
import { GetServerSidePropsContext } from 'next'

import { SpecialOfferPage } from '@/components/Pages/SpecialOffer'

import { initializeStore } from '@/redux/store'
import { getSettings } from '@/redux/actions'

const SpecialOffer = () => {
  return <SpecialOfferPage />
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default SpecialOffer

